import { getBackendConnection } from "api/queries/BackendConnectionAPI";

export const BackendConnectionEntity = {
    GetBackendConnection: async () => {
        try {
            const backendConnection = await getBackendConnection();
            return backendConnection as unknown as string;
        } catch (error) {
            console.error(error);
        }
    },
};
